// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.singlecourse {
  margin-bottom: 5px;
  width: 100%;
  margin-top: 3px;
  padding: 0px 5px;
}

.singlecourse h3 {
  margin: 0px 0px 15px;
}

/*.arrow {*/
/*width: 0;*/
/*height: 0;*/
/*border-style: solid;*/
/*border-width: 30px 250px 0 250px;*/
/*border-color: #e5e5e5 transparent transparent transparent !important;*/
/*}*/

.arrow {
  display: none;
  position: absolute;
  bottom: -3px;
  width: calc(100% - 10px);
}

.assignment.rightColumn .arrow,
.assignment.leftColumn .arrow {
  width: calc(100% - 5px);
}

.arrow .arrowTopBorder {
  height: 1.1rem;
  background-color: #e5e5e5;
}

.arrow .point {
  width: 100%;
  position: absolute;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 10;
}

.singlecourse .body {
  background-color: #f2f2f2;
  overflow: hidden;
  padding: 5px;
  padding-left: 10px;
}

.users .row .col-md-12 h4,
.singlecourse .body h4 {
  margin: 0px;
}

.singlecourse .body .info {
}

.singlecourse .body .info .content {
  overflow: hidden;
  width: 300px;
  float: left;
  margin-right: 15px;
  position: relative;
}

.singlecourse .body .info .content .mainImg {
  background-color: #bbb;
  float: left;
  margin-right: 15px;
  width: 300px;
}

.singlecourse .closer {
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  height: 30px;
  line-height: 27px;
  right: 15px;
  width: 30px;
}

.singlecourse .body .info .infoHolder {
  float: left;
  width: 100%;
}

.singlecourse .offeringSlide {
  background-color: #fff;
  display: none;
  max-height: 120px;
  overflow: scroll;
  position: absolute;
  right: 10px;
  width: 50%;
  z-index: 100;
}

.singlecourse .body .info .infoHolder .apiActionLoader {
  margin-bottom: 7px;
  overflow: hidden;
}

/* code, type and source on slide down */
.slideDownMeta {
  padding-left: 0px;
  padding-top: 4rem;
  color: black;
  font-size: 16px;
  list-style: none;
}

.dateBlock {
  display: block;
}

.slideDownMeta li {
  display: inline-block;
}

.slideDownMeta li.space {
  margin: 0px 15px;
}

.singlecourse .offerings {
  width: 100%;
}

/***** assignment list & catalog list pages *****/
/* Need some specific styling for these pages */
#assignmentCourseList #singlecourse {
  margin-left: calc(8.3% * 3);
  width: calc(100% - 8.3% * 3);
  padding: 0;
  margin-top: 0;
}
/* Hide the meta information on the single course slide down on these pages only */
#assignmentCourseList #singlecourse .slideDownMeta {
  display: none;
}
#assignmentCourseList #singlecourse .body {
  background-color: white;
}
#assignmentCourseList #singlecourse .body .description {
  padding-bottom: 1rem;
}

.ScheduleCourseModal .title {
  font-weight: bold;
}

.ScheduleCourseModal .modal .requestContainer {
  width: 100%;
}

.ScheduleCourseModal .dateContainer {
  position: relative;
  overflow: hidden;
  display: flex;
}

.ScheduleCourseModal .actionHolder {
  margin-top: 1rem;
  overflow: visible;
  width: 100%;
}

.ScheduleCourseModal .RequestApprovalbtn {
  padding: 1rem 3rem !important;
}

.ScheduleCourseModal .Schedulebtn {
  padding: 1rem 6rem !important;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/singleCourseSlideDown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,WAAW;AACX,YAAY;AACZ,aAAa;AACb,uBAAuB;AACvB,oCAAoC;AACpC,wEAAwE;AACxE,IAAI;;AAEJ;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,wCAAwC;EACxC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,iDAAiD;AACjD,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,aAAa;AACf;AACA,kFAAkF;AAClF;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".singlecourse {\n  margin-bottom: 5px;\n  width: 100%;\n  margin-top: 3px;\n  padding: 0px 5px;\n}\n\n.singlecourse h3 {\n  margin: 0px 0px 15px;\n}\n\n/*.arrow {*/\n/*width: 0;*/\n/*height: 0;*/\n/*border-style: solid;*/\n/*border-width: 30px 250px 0 250px;*/\n/*border-color: #e5e5e5 transparent transparent transparent !important;*/\n/*}*/\n\n.arrow {\n  display: none;\n  position: absolute;\n  bottom: -3px;\n  width: calc(100% - 10px);\n}\n\n.assignment.rightColumn .arrow,\n.assignment.leftColumn .arrow {\n  width: calc(100% - 5px);\n}\n\n.arrow .arrowTopBorder {\n  height: 1.1rem;\n  background-color: #e5e5e5;\n}\n\n.arrow .point {\n  width: 100%;\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\n.singlecourse .body {\n  background-color: #f2f2f2;\n  overflow: hidden;\n  padding: 5px;\n  padding-left: 10px;\n}\n\n.users .row .col-md-12 h4,\n.singlecourse .body h4 {\n  margin: 0px;\n}\n\n.singlecourse .body .info {\n}\n\n.singlecourse .body .info .content {\n  overflow: hidden;\n  width: 300px;\n  float: left;\n  margin-right: 15px;\n  position: relative;\n}\n\n.singlecourse .body .info .content .mainImg {\n  background-color: #bbb;\n  float: left;\n  margin-right: 15px;\n  width: 300px;\n}\n\n.singlecourse .closer {\n  -webkit-border-radius: 15px;\n  -moz-border-radius: 15px;\n  border-radius: 15px;\n  height: 30px;\n  line-height: 27px;\n  right: 15px;\n  width: 30px;\n}\n\n.singlecourse .body .info .infoHolder {\n  float: left;\n  width: 100%;\n}\n\n.singlecourse .offeringSlide {\n  background-color: #fff;\n  display: none;\n  max-height: 120px;\n  overflow: scroll;\n  position: absolute;\n  right: 10px;\n  width: 50%;\n  z-index: 100;\n}\n\n.singlecourse .body .info .infoHolder .apiActionLoader {\n  margin-bottom: 7px;\n  overflow: hidden;\n}\n\n/* code, type and source on slide down */\n.slideDownMeta {\n  padding-left: 0px;\n  padding-top: 4rem;\n  color: black;\n  font-size: 16px;\n  list-style: none;\n}\n\n.dateBlock {\n  display: block;\n}\n\n.slideDownMeta li {\n  display: inline-block;\n}\n\n.slideDownMeta li.space {\n  margin: 0px 15px;\n}\n\n.singlecourse .offerings {\n  width: 100%;\n}\n\n/***** assignment list & catalog list pages *****/\n/* Need some specific styling for these pages */\n#assignmentCourseList #singlecourse {\n  margin-left: calc(8.3% * 3);\n  width: calc(100% - 8.3% * 3);\n  padding: 0;\n  margin-top: 0;\n}\n/* Hide the meta information on the single course slide down on these pages only */\n#assignmentCourseList #singlecourse .slideDownMeta {\n  display: none;\n}\n#assignmentCourseList #singlecourse .body {\n  background-color: white;\n}\n#assignmentCourseList #singlecourse .body .description {\n  padding-bottom: 1rem;\n}\n\n.ScheduleCourseModal .title {\n  font-weight: bold;\n}\n\n.ScheduleCourseModal .modal .requestContainer {\n  width: 100%;\n}\n\n.ScheduleCourseModal .dateContainer {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n}\n\n.ScheduleCourseModal .actionHolder {\n  margin-top: 1rem;\n  overflow: visible;\n  width: 100%;\n}\n\n.ScheduleCourseModal .RequestApprovalbtn {\n  padding: 1rem 3rem !important;\n}\n\n.ScheduleCourseModal .Schedulebtn {\n  padding: 1rem 6rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
